export class RequestXplorerCard {
        fullName: string;
        profession: string;
        companyName: string;
        designation: string;
        platform: string;
        username: string;
        preferredNameOnCard: string;
        ReferralCode: string;
}
